import { Component, OnInit } from '@angular/core';
import { indexarFormulasContextos, listarFormulasContexto } from '@shared/components/formula/utils/formula-contexto.util';
import { coletarCiclosEmpresa, registrarCicloEmpresa } from '@shared/components/formula/utils/formula-estados.util';
import { FormulaCicloDialogComponent, FormulaCicloDialogData, FormulaCicloDialogResult } from '@shared/components/formula/formula-ciclo-dialog/formula-ciclo-dialog.component';
import { FormulaErrorCodeEnum } from '@shared/enums/formula/formula-error-code.enum';
import { TipoEntidadeFormulaEnum } from '@shared/enums/formula/tipo-entidade-formula.enum';
import { FormulaCicloEmpresaRascunho } from '@shared/services/structs/formula/formula-ciclo-empresa-rascunho.struct';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';
import { ConfirmModalComponent } from '@shared/components/confirm-modal/confirm-modal.component';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { RegraTributariaService } from '@shared/services/apis/motor-fiscal/regra-tributaria.service';
import { FormulaCatalogoService } from '@shared/services/apis/motor-fiscal/formula-catalogo.service';
import { MotorFiscalLookupService } from '@shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { LookupService } from '@shared/services/apis/produto/produto-lookup.service';
import { ModeloDocumentoService } from '@shared/services/apis/dfe/modelo-documento.service';
import { RegraTributariaCompletaRequest } from '@shared/services/requests/motor-fiscal/regra-tributaria-completa.request';
import { RegraTributariaCompletaResponse } from '@shared/services/responses/motor-fiscal/regra-tributaria-completa.response';
import { RegraTributariaSalvarResponse } from '@shared/services/responses/motor-fiscal/regra-tributaria-salvar.response';
import { CstIbsCbsStruct } from '@shared/services/structs/motor-fiscal/cst-ibs-cbs.struct';
import { CodigoCreditoPresumidoStruct } from '@shared/services/structs/motor-fiscal/codigo-credito-presumido.struct';
import { LookupItemStruct } from '@shared/services/structs/motor-fiscal/lookup-item.struct';
import { CClassTribIbsCbsStruct } from '@shared/services/structs/motor-fiscal/c-class-trib-ibs-cbs.struct';
import { CstIbsCbsCclasstribIbsCbsStruct } from '@shared/services/structs/motor-fiscal/cst-ibs-cbs-cclasstrib-ibs-cbs.struct';
import { RegraTributariaEscopoStruct } from '@shared/services/structs/motor-fiscal/regra-tributaria-escopo.struct';
import { NaturezaOperacaoRegraTributariaStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-regra-tributaria.struct';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaCatalogoGrupoStruct } from '@shared/services/structs/formula/formula-catalogo-grupo.struct';
import { TipoFormulaEnum } from '@shared/enums/formula/tipo-formula.enum';
import { FormulaItemStruct } from '@shared/services/structs/formula/formula-item.struct';
import { LookupItemStruct as PessoaLookupItemStruct } from '@shared/services/structs/pessoa/lookup-item.struct';
import { ModeloDocumento } from '@shared/services/models/dfe/modelo-documento.model';
import { ModeloDocumentoLookupResponse } from '@shared/services/responses/dfe/modelo-documento-lookup.response';
import { ModeloDocumentoEnum } from '@shared/enums/dfe/modelo-documento.enum';
import { TipoEscopoEnum } from '@shared/enums/motor-fiscal/tipo-escopo.enum';
import { RegraTributariaErrorCodeEnum } from '@shared/enums/motor-fiscal/regra-tributaria-error-code.enum';
import { HeaderComponent } from '@shared/components/header/header.component';
import { FooterActionComponent } from '@shared/components/footer-action/footer-action.component';
import { aplicarIndicadoresRegraTributaria, montarIndicadoresRegraTributaria, RegraTributariaIndicadoresUi } from '@shared/constants/motor-fiscal/regra-tributaria-indicadores.util';
import { RegraTributariaTributacaoStepComponent } from './steps/regra-tributaria-tributacao-step/regra-tributaria-tributacao-step.component';
import { RegraTributariaEscopoStepComponent } from './steps/regra-tributaria-escopo-step/regra-tributaria-escopo-step.component';
import { RegraTributariaNaturezaStepComponent } from './steps/regra-tributaria-natureza-step/regra-tributaria-natureza-step.component';
import { RegraTributariaRevisaoStepComponent } from './steps/regra-tributaria-revisao-step/regra-tributaria-revisao-step.component';
import { WizardStepsComponent } from '@shared/components/wizard-steps/wizard-steps.component';

/**
 * Cadastro/edição de Regra Tributária (IBS/CBS/IS).
 *
 * Duas formas de uso da MESMA tela componentizada:
 *  - Modo único (regra padrão): acessada pelo menu; abas de tributos diretas, sem etapas.
 *  - Modo etapas (regra convencional): acessada pela listagem; nesta fase renderiza apenas a
 *    etapa "Tributação" (as mesmas abas do tipo único). As demais etapas entram em fases futuras.
 *
 * Um único FormGroup pai com um sub-grupo por tributo; cada aba/seção grava sua parte nessa árvore
 * e o salvamento é uma chamada única, permitindo o save incremental no backend.
 */
@Component({
    selector: 'app-regra-tributaria-cadastro',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        HeaderComponent,
        FooterActionComponent,
        RegraTributariaTributacaoStepComponent,
        RegraTributariaEscopoStepComponent,
        RegraTributariaNaturezaStepComponent,
        RegraTributariaRevisaoStepComponent,
        WizardStepsComponent,
    ],
    templateUrl: './regra-tributaria-cadastro.component.html',
    styleUrl: './regra-tributaria-cadastro.component.css',
})
export class RegraTributariaCadastroComponent implements OnInit {
    public moduloEnum = ModuloEnum.Configuracoes;
    public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_ReformaTributaria;

    public form!: FormGroup;
    public isModoPadrao = false;
    public isEditMode = false;
    public idRegraTributaria: number | null = null;
    public isLoading = false;
    public isSaving = false;

    /** True quando há alterações não salvas no form, para confirmar a saída. */
    public isDirty = false;
    /** Guarda o valueChanges do form: ignora o patchValue do carregamento inicial. */
    private _cargaConcluida = false;

    public csts: CClassTribIbsCbsStruct[] = [];
    public cclasstribs: CClassTribIbsCbsStruct[] = [];
    public relacoesCstCclasstrib: CstIbsCbsCclasstribIbsCbsStruct[] = [];
    public modelosDocumento: ModeloDocumento[] = [];
    public listaRegimeTributario: PessoaLookupItemStruct[] = [];
    public listaTipoTributario: PessoaLookupItemStruct[] = [];
    public codigosCreditoPresumido: CodigoCreditoPresumidoStruct[] = [];
    public indicadoresDoacao: LookupItemStruct[] = [];
    public naturezasSelecionadas: NaturezaOperacaoRegraTributariaStruct[] = [];
    /** Indicadores derivados do CST/cClassTrib selecionado, para os alertas de grupo não configurável e a visibilidade da Tributação Regular. */
    public indicadoresUi: RegraTributariaIndicadoresUi | null = null;

    /** Carimbo de concorrência dos vínculos da linhagem carregado na tela (trava otimista). */
    private _carimboVinculos: string | null = null;

    /** Ids das linhas da versão carregada (save incremental): amarram a origem de cada grupo/seção/escopo. */
    private _origemIds: Record<string, number | null> = {};
    private _escopoOrigemPorTipo = new Map<number, number | null>();

    // Fórmulas do catálogo específico do cadastro, distribuídas às abas e seções da regra.
    public formulasCbs: FormulaCatalogoItemStruct[] = [];
    public formulasIbsUf: FormulaCatalogoItemStruct[] = [];
    public formulasIbsMunicipio: FormulaCatalogoItemStruct[] = [];
    public formulasTribRegular: FormulaCatalogoItemStruct[] = [];
    public formulasIbsCbs: FormulaCatalogoItemStruct[] = [];
    public formulasMonoPadrao: FormulaCatalogoItemStruct[] = [];
    public formulasMonoRetencao: FormulaCatalogoItemStruct[] = [];
    public formulasMonoRetida: FormulaCatalogoItemStruct[] = [];
    public formulasMonoDiferimento: FormulaCatalogoItemStruct[] = [];
    public formulasCreditoPresumidoOperacao: FormulaCatalogoItemStruct[] = [];
    public formulasCreditoPresumidoIbs: FormulaCatalogoItemStruct[] = [];
    public formulasCreditoPresumidoCbs: FormulaCatalogoItemStruct[] = [];
    /** Todas as fórmulas do catálogo, para as variáveis das observações da regra. */
    public formulasRegra: FormulaCatalogoItemStruct[] = [];

    // Etapas do tipo convencional (apenas Tributação implementada nesta fase).
    public readonly etapas = ['Tributação', 'Escopo', 'Natureza da Operação', 'Revisão e Confirmação'];
    public readonly descricoesEtapas = [
        'Informe os parâmetros tributários (CST, alíquotas, reduções e regras de cálculo para IBS, CBS e IS).',
        'Defina os escopos de aplicação da regra tributária (UFs, municípios, NCMs, regimes tributários, etc.).',
        'Selecione ou vincule as naturezas de operação associadas a esta regra tributária.',
        'Revise todas as informações preenchidas antes de finalizar o cadastro da regra tributária.'
    ];
    public etapaAtual = 0;


    // ── Navegação por etapas (tipo convencional) ─────────────────────────────

    public get isModoEtapas(): boolean {
        return !this.isModoPadrao;
    }

    public get isUltimaEtapa(): boolean {
        return this.etapaAtual === this.etapas.length - 1;
    }

    /** Rótulo do botão primário do footer: "Próximo" entre etapas, "Salvar" na última (ou no tipo padrão). */
    public get labelBotaoSalvar(): string {
        return (this.isModoPadrao || this.isUltimaEtapa) ? 'Salvar' : 'Próximo';
    }

    /** Rótulo do botão secundário: "Voltar" durante a navegação entre etapas, senão "Cancelar". */
    public get labelBotaoCancelar(): string {
        return (this.isModoEtapas && this.etapaAtual > 0) ? 'Voltar' : 'Cancelar';
    }

    public onBotaoSalvar(): void {
        if (this.isModoPadrao || this.isUltimaEtapa) {
            this.salvar();
        } else {
            if (!this.podeAvancarDaEtapa(this.etapaAtual)) return;
            if (this.etapaAtual === 1) this.avisarSobreposicaoSeHouver();
            this.etapaAtual++;
        }
    }

    /**
     * Aviso antecipado (não bloqueante) de conflito de escopo sem desempate, ao sair da
     * etapa de Escopo. O bloqueio real — que não pode ser contornado — acontece no salvar.
     */
    private avisarSobreposicaoSeHouver(): void {
        if (this.isModoPadrao) return;
        this.regraService.validarSobreposicao(this.montarRequest(), this.idRegraTributaria).subscribe(r => {
            if (r?.regrasEmConflito?.length) {
                const nomes = r.regrasEmConflito.join(', ');
                this.alertService.show('Atenção', `Esta regra possui escopos conflitantes com ${nomes} no mesmo modelo de documento e sem critério de desempate. Ajuste antes de salvar.`, AlertType.warning);
            }
        });
    }

    /** Validações necessárias para avançar a partir de uma etapa (sinaliza/avisa quando bloqueia). */
    private podeAvancarDaEtapa(etapa: number): boolean {
        if (etapa === 0) return this.validarTributacao();
        return true;
    }

    /**
     * Atalho pelo indicador de etapas. Voltar é sempre permitido; avançar exige passar pelas
     * validações de cada etapa do caminho (evita burlar validações pulando etapas). Ao bloquear,
     * para na primeira etapa pendente.
     */
    public onEtapaSelecionada(destino: number): void {
        if (this.isModoPadrao) return;
        if (destino === this.etapaAtual || destino < 0 || destino >= this.etapas.length) return;

        if (this.etapaAtual === 1) this.avisarSobreposicaoSeHouver();

        if (destino < this.etapaAtual) {
            this.etapaAtual = destino;
            return;
        }

        for (let etapa = this.etapaAtual; etapa < destino; etapa++) {
            if (!this.podeAvancarDaEtapa(etapa)) {
                this.etapaAtual = etapa;
                return;
            }
        }
        this.etapaAtual = destino;
    }

    /** Valida os campos obrigatórios das seções ativas; sinaliza os inválidos e avisa o usuário. */
    private validarTributacao(): boolean {
        const grupoSemParametro = this.mensagemGrupoSemParametro();
        if (grupoSemParametro || this.form.invalid) {
            this.form.markAllAsTouched();
            this.alertService.show('Aviso', grupoSemParametro ?? 'Preencha os campos obrigatórios das seções ativas.', AlertType.warning);
            return false;
        }
        if (!this.isModoPadrao && (this.form.get('modelosDocumento')?.value?.length ?? 0) === 0) {
            this.alertService.show('Atenção', 'Selecione ao menos um modelo de documento.', AlertType.warning);
            return false;
        }
        return true;
    }

    /**
     * Grupo ligado sem os parâmetros que o cálculo usa: mesmas regras e mensagens do salvar da API. Preenchido é não
     * vazio (zero é aceito), negativo é recusado e percentual não passa de 100. Subgrupo só conta com o grupo pai ligado.
     */
    private mensagemGrupoSemParametro(): string | null {
        const v = this.form.getRawValue();
        const vazio = (...valores: unknown[]): boolean => valores.some(valor => valor == null || valor === '');
        const percentual = (valor: number | null, descricao: string): string | null =>
            valor != null && (valor < 0 || valor > 100) ? `${descricao} deve estar entre 0 e 100.` : null;
        const valorPositivo = (valor: number | null, descricao: string): string | null =>
            valor != null && valor < 0 ? `${descricao} não pode ser negativo.` : null;
        const ibsCbs = !!v.ibsCbs?.isAtivo;
        const tributacaoRegular = ibsCbs && !!v.tributacaoRegular?.isAtivo;
        const mono = !!v.mono?.isAtivo;
        const creditoPresumido = !!v.creditoPresumido?.isAtivo;
        if (!ibsCbs && !tributacaoRegular && !mono && !creditoPresumido) return null;

        if (vazio(v.classificacao?.cstIbsCbs, v.classificacao?.cclassTrib)) return 'Informe o CST e o cClassTrib do IBS/CBS.';

        if (ibsCbs) {
            if (v.ibsCbs.reducaoBaseCalculoAtivo) {
                if (vazio(v.ibsCbs.percentualReducaoBaseCalculo)) return 'Informe o percentual de redução da base de cálculo do IBS/CBS.';
                const erro = percentual(v.ibsCbs.percentualReducaoBaseCalculo, 'O percentual de redução da base de cálculo do IBS/CBS');
                if (erro) return erro;
            }
            const entes: Array<[any, string]> = [[v.ibsCbs.cbs, 'da CBS'], [v.ibsCbs.ibsUf, 'do IBS UF'], [v.ibsCbs.ibsMunicipio, 'do IBS município']];
            for (const [ente, nome] of entes) {
                const subgrupos: Array<[boolean, number | null, string]> = [
                    [!!ente?.reducaoAtivo, ente?.pRedAliq, 'redução'],
                    [!!ente?.diferimentoAtivo, ente?.pDif, 'diferimento'],
                    [!!ente?.devolucaoAtivo, ente?.pDevTrib, 'devolução'],
                ];
                for (const [ligado, valor, subgrupo] of subgrupos) {
                    if (!ligado) continue;
                    if (vazio(valor)) return `Informe o percentual de ${subgrupo} ${nome}.`;
                    const erro = percentual(valor, `O percentual de ${subgrupo} ${nome}`);
                    if (erro) return erro;
                }
            }
        }

        if (tributacaoRegular) {
            const regular = v.tributacaoRegular;
            if (vazio(regular.cstIbsCbs, regular.cclassIbsCbs, regular.pAliqEfetivaIbsUf, regular.pAliqEfetivaIbsMunicipio, regular.pAliqEfetivaCbs)) {
                return 'Informe o CST, o cClassTrib e as alíquotas efetivas da tributação regular.';
            }
            const erro = percentual(regular.pAliqEfetivaIbsUf, 'A alíquota efetiva do IBS UF da tributação regular')
                ?? percentual(regular.pAliqEfetivaIbsMunicipio, 'A alíquota efetiva do IBS município da tributação regular')
                ?? percentual(regular.pAliqEfetivaCbs, 'A alíquota efetiva da CBS da tributação regular');
            if (erro) return erro;
        }

        if (mono) {
            const modalidades: Array<[boolean, number | null, number | null, string]> = [
                [!!v.mono.padrao?.isAtivo, v.mono.padrao?.adRemIbs, v.mono.padrao?.adRemCbs, 'padrão'],
                [!!v.mono.retencao?.isAtivo, v.mono.retencao?.adRemIbsReten, v.mono.retencao?.adRemCbsReten, 'com retenção'],
                [!!v.mono.retidaAnteriormente?.isAtivo, v.mono.retidaAnteriormente?.adRemIbsRet, v.mono.retidaAnteriormente?.adRemCbsRet, 'retido anteriormente'],
            ];
            for (const [ligado, adRemIbs, adRemCbs, nome] of modalidades) {
                if (!ligado) continue;
                if (vazio(adRemIbs, adRemCbs)) return `Informe o ad rem do IBS e da CBS do monofásico ${nome}.`;
                const erro = valorPositivo(adRemIbs, `O ad rem do IBS do monofásico ${nome}`)
                    ?? valorPositivo(adRemCbs, `O ad rem da CBS do monofásico ${nome}`);
                if (erro) return erro;
            }
            const diferimento = v.mono.diferimento;
            if (diferimento?.isAtivo) {
                if (vazio(diferimento.pDifIbs, diferimento.pDifCbs)) return 'Informe os percentuais de diferimento do monofásico.';
                const erro = percentual(diferimento.pDifIbs, 'O percentual de diferimento do IBS do monofásico')
                    ?? percentual(diferimento.pDifCbs, 'O percentual de diferimento da CBS do monofásico');
                if (erro) return erro;
            }
        }

        if (creditoPresumido) {
            if (vazio(v.creditoPresumido.cCredPres)) return 'Informe o código do crédito presumido.';
            const percentuais: Array<[any, string]> = [[v.creditoPresumido.ibs, 'do IBS'], [v.creditoPresumido.cbs, 'da CBS']];
            for (const [grupo, nome] of percentuais) {
                if (!grupo?.isAtivo) continue;
                if (vazio(grupo.pCredPres)) return `Informe o percentual de crédito presumido ${nome}.`;
                const erro = percentual(grupo.pCredPres, `O percentual de crédito presumido ${nome}`);
                if (erro) return erro;
            }
        }
        return null;
    }

    public onBotaoCancelar(): void {
        if (this.isModoEtapas && this.etapaAtual > 0) {
            this.etapaAtual--;
        } else {
            this.cancelar();
        }
    }

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog,
        private regraService: RegraTributariaService,
        private formulaService: FormulaCatalogoService,
        private motorFiscalLookupService: MotorFiscalLookupService,
        private produtoLookupService: LookupService,
        private modeloDocumentoService: ModeloDocumentoService,
        private alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.isModoPadrao = this.route.snapshot.data['modoPadrao'] === true;
        this.form = this.montarForm();

        const idParam = this.route.snapshot.paramMap.get('idRegraTributaria');
        this.idRegraTributaria = idParam ? Number(idParam) : null;

        this.registrarRecalculoIndicadores();
        // Ignora o patchValue do carregamento inicial: só marca alteração após a carga concluir.
        this.form.valueChanges.subscribe(() => {
            if (this._cargaConcluida) this.isDirty = true;
        });
        this.carregar();
    }

    private montarForm(): FormGroup {
        return this.fb.group({
            nome: ['', Validators.required],
            isAtivo: [true],
            // Textos impressos na nota quando esta regra for a aplicada (antes ficavam na natureza).
            observacao: [null as string | null],
            informacaoFisco: [null as string | null],
            modelosDocumento: [[] as string[]],
            // Rascunhos de ciclo da regra configurados no modal do salvar (um por ciclo); vão em ciclosEmpresa.
            _ciclosEmpresa: [[] as FormulaCicloEmpresaRascunho[]],
            classificacao: this.fb.group({
                cstIbsCbs: [null, Validators.required],
                cclassTrib: [null, Validators.required],
                indDoacao: [null],
            }),
            ibsCbs: this.fb.group({
                isAtivo: [false],
                // Card "Redução da base de cálculo": o toggle é só da tela (ligado = percentual preenchido).
                reducaoBaseCalculoAtivo: [false], percentualReducaoBaseCalculo: [null],
                _estadosFormulas: [[]],
                cbs: this.fb.group({
                    isAtivo: [false],
                    reducaoAtivo: [false], pRedAliq: [null],
                    diferimentoAtivo: [false], pDif: [null],
                    devolucaoAtivo: [false], pDevTrib: [null],
                    _estadosFormulas: [[]],
                }),
                ibsUf: this.fb.group({
                    isAtivo: [false],
                    reducaoAtivo: [false], pRedAliq: [null],
                    diferimentoAtivo: [false], pDif: [null],
                    devolucaoAtivo: [false], pDevTrib: [null],
                    _estadosFormulas: [[]],
                }),
                ibsMunicipio: this.fb.group({
                    isAtivo: [false],
                    reducaoAtivo: [false], pRedAliq: [null],
                    diferimentoAtivo: [false], pDif: [null],
                    devolucaoAtivo: [false], pDevTrib: [null],
                    _estadosFormulas: [[]],
                }),
            }),
            tributacaoRegular: this.fb.group({
                isAtivo: [false],
                cstIbsCbs: [null], cclassIbsCbs: [null],
                pAliqEfetivaIbsUf: [null], pAliqEfetivaIbsMunicipio: [null], pAliqEfetivaCbs: [null],
                _estadosFormulas: [[]],
            }),
            mono: this.fb.group({
                isAtivo: [false],
                padrao: this.fb.group({ isAtivo: [false], adRemIbs: [null], adRemCbs: [null], _estadosFormulas: [[]] }),
                retencao: this.fb.group({ isAtivo: [false], adRemIbsReten: [null], adRemCbsReten: [null], _estadosFormulas: [[]] }),
                retidaAnteriormente: this.fb.group({ isAtivo: [false], adRemIbsRet: [null], adRemCbsRet: [null], _estadosFormulas: [[]] }),
                diferimento: this.fb.group({ isAtivo: [false], pDifIbs: [null], pDifCbs: [null], _estadosFormulas: [[]] }),
            }),
            creditoPresumido: this.fb.group({
                isAtivo: [false],
                cCredPres: [null],
                _estadosFormulas: [[]],
                ibs: this.fb.group({ isAtivo: [false], pCredPres: [null], _estadosFormulas: [[]] }),
                cbs: this.fb.group({ isAtivo: [false], pCredPres: [null], _estadosFormulas: [[]] }),
            }),
            impostoSeletivo: this.fb.group({
                isAtivo: [false],
                cstIs: [null], cclassTribIs: [null], pIs: [null], adRemIs: [null],
                _estadosFormulas: [[]],
            }),
            escopo: this.fb.group({
                ncms: [[] as string[]],
                produtos: [[] as { codigo: string; descricao: string }[]],
                // "true"/"false": mesma representação do booleano de contribuinte de IBS/CBS na
                // Pessoa e da comparação de escopo no Motor Fiscal.
                contribIbsCbs: [[] as string[]],
                regimesTrib: [[] as number[]],
                tiposTrib: [[] as number[]],
            }),
            naturezas: [[] as number[]],
        });
    }

    /**
     * Ao trocar CST/cClassTrib, recalcula os toggles de ativação conforme indicadores do catálogo. CBS, IBS UF e
     * IBS Município não têm toggle próprio: acompanham o toggle do IBS/CBS.
     */
    private registrarRecalculoIndicadores(): void {
        const classificacao = this.form.get('classificacao') as FormGroup;
        classificacao.valueChanges.subscribe(() => this.recalcularIndicadores());
        this.form.get('ibsCbs.isAtivo')?.valueChanges.subscribe(ativo => this.sincronizarEntesIbsCbs(!!ativo));
    }

    private recalcularIndicadores(): void {
        const cst = this.cstSelecionado()?.indicadores;
        const cclass = this.cclasstribSelecionado()?.indicadores;
        const ui = aplicarIndicadoresRegraTributaria(cst, cclass);
        this.indicadoresUi = ui;

        // Redução e diferimento de cada ente pré-ligam pelo indicador daquele ente. A devolução não pré-liga: o
        // indicador só diz que o grupo pode existir, e o usuário liga quando usar (decisão do desenvolvedor, 2026-10-30).
        const ente = (indicador: typeof ui.ibsCbs.cbs) => ({
            isAtivo: ui.ibsCbs.ativo,
            reducaoAtivo: indicador.reducao,
            diferimentoAtivo: indicador.diferimento,
        });
        this.form.get('ibsCbs')?.patchValue({
            isAtivo: ui.ibsCbs.ativo,
            // O redutor de base pré-liga só pelo indicador do CST (222); o usuário liga e desliga em qualquer CST.
            reducaoBaseCalculoAtivo: ui.campos.percentualReducaoBaseCalculo,
            cbs: ente(ui.ibsCbs.cbs),
            ibsUf: ente(ui.ibsCbs.ibsUf),
            ibsMunicipio: ente(ui.ibsCbs.ibsMunicipio),
        });
        this.form.get('tributacaoRegular')?.patchValue({ isAtivo: ui.tributacaoRegular });
        this.form.get('mono')?.patchValue({
            isAtivo: ui.mono.ativo,
            padrao: { isAtivo: ui.mono.padrao },
            retencao: { isAtivo: ui.mono.retencao },
            retidaAnteriormente: { isAtivo: ui.mono.retidaAnteriormente },
            // A tabela cClassTrib v1.70 não tem indicador do gMonoDif: o diferimento é ativado manualmente na seção.
            diferimento: { isAtivo: false },
        });
        this.form.get('creditoPresumido')?.patchValue({ isAtivo: ui.creditoPresumido });
    }

    /** CBS, IBS UF e IBS Município seguem o toggle do IBS/CBS: ligado calcula os três, desligado nenhum. */
    private sincronizarEntesIbsCbs(ativo: boolean): void {
        ['cbs', 'ibsUf', 'ibsMunicipio'].forEach(ente => {
            const control = this.form.get(`ibsCbs.${ente}.isAtivo`);
            if (control && control.value !== ativo) control.setValue(ativo);
        });
    }

    private cstSelecionado(): CClassTribIbsCbsStruct | undefined {
        const codigo = this.form.get('classificacao')?.get('cstIbsCbs')?.value;
        return this.csts.find(c => c.codigo === codigo);
    }

    private cclasstribSelecionado(): CClassTribIbsCbsStruct | undefined {
        const codigo = this.form.get('classificacao')?.get('cclassTrib')?.value;
        return this.cclasstribs.find(c => c.codigo === codigo);
    }

    private carregar(): void {
        this.isLoading = true;
        forkJoin({
            bootstrap: this.motorFiscalLookupService.getRegraTributariaCadastroLookup(),
            modelos: this.modeloDocumentoService.listar(),
            catalogo: this.formulaService.getContexto('regra-tributaria'),
        }).subscribe({
            next: ({ bootstrap, modelos, catalogo }) => {
                this.csts = bootstrap?.ibsCbs?.csts ?? [];
                this.cclasstribs = bootstrap?.ibsCbs?.cclasstribs ?? [];
                this.relacoesCstCclasstrib = bootstrap?.ibsCbs?.relacoesCstCclasstrib ?? [];
                this.modelosDocumento = (modelos?.modelos ?? []).filter(modelo =>
                    modelo.idModeloDocumento === ModeloDocumentoEnum.NFe ||
                    modelo.idModeloDocumento === ModeloDocumentoEnum.NFCe,
                );
                this.listaRegimeTributario = bootstrap?.regimesTributarios ?? [];
                this.listaTipoTributario = bootstrap?.tiposTributario ?? [];
                this.codigosCreditoPresumido = bootstrap?.codigosCreditoPresumido ?? [];
                this.indicadoresDoacao = bootstrap?.indicadoresDoacao ?? [];
                if (catalogo?.isError) {
                    this.alertService.show(
                        'Erro',
                        catalogo.errorDescription || 'Não foi possível carregar as fórmulas da regra tributária.',
                        AlertType.error,
                    );
                    this.distribuirFormulas([]);
                } else {
                    this.distribuirFormulas(catalogo?.grupos ?? []);
                }

                if (this.isModoPadrao) {
                    this.carregarPadrao();
                } else if (this.idRegraTributaria) {
                    this.carregarCompleto(this.idRegraTributaria);
                } else {
                    this.isLoading = false;
                    this._cargaConcluida = true;
                }
            },
            error: () => {
                this.isLoading = false;
                this._cargaConcluida = true;
                this.alertService.show('Erro', 'Não foi possível carregar os dados da regra tributária.', AlertType.error);
            },
        });
    }

    private carregarPadrao(): void {
        this.regraService.getPadrao().subscribe({
            next: (r) => {
                // Empresa sem regras: cria as regras padrão e carrega a regra geral (mesmo molde da natureza e do DIFAL).
                if (r.isError && r.errorCode === RegraTributariaErrorCodeEnum.SeedPendente) {
                    this.inicializarRegras();
                    return;
                }
                if (r.isError) {
                    this.alertService.show('Erro', r.errorDescription || 'Não foi possível carregar a regra tributária padrão.', AlertType.error);
                }
                this.aplicarResponse(r);
                this.isLoading = false;
                this._cargaConcluida = true;
            },
            error: () => { this.isLoading = false; this._cargaConcluida = true; this.alertService.show('Erro', 'Não foi possível carregar a regra tributária padrão.', AlertType.error); },
        });
    }

    /** Cria as regras tributárias padrão da empresa e carrega a regra padrão. */
    private inicializarRegras(): void {
        this.alertService.show('Informação', 'Carregando as configurações base...', AlertType.info);
        this.regraService.seed().subscribe({
            next: seed => {
                if (seed.isError) {
                    this.isLoading = false;
                    this._cargaConcluida = true;
                    this.alertService.show('Erro', seed.errorDescription || 'Não foi possível inicializar as regras tributárias.', AlertType.error);
                    return;
                }
                this.carregarPadrao();
            },
            error: () => {
                this.isLoading = false;
                this._cargaConcluida = true;
                this.alertService.show('Erro', 'Não foi possível inicializar as regras tributárias.', AlertType.error);
            },
        });
    }

    private carregarCompleto(id: number): void {
        this.regraService.getCompleto(id).subscribe({
            next: (r) => {
                this.isLoading = false;
                this._cargaConcluida = true;
                if (r.isError) {
                    // Código local do endpoint: regra inexistente, inclusive versões encerradas pelo save incremental.
                    if (r.errorCode === 1) {
                        this.alertService.show('Atenção', 'A regra tributária informada não foi encontrada.', AlertType.warning);
                        this.router.navigate(['/configuracoes/reforma-tributaria/regras']);
                        return;
                    }
                    this.alertService.show('Erro', r.errorDescription || 'Não foi possível carregar a regra tributária.', AlertType.error);
                    return;
                }
                this.aplicarResponse(r);
            },
            error: () => { this.isLoading = false; this._cargaConcluida = true; this.alertService.show('Erro', 'Não foi possível carregar a regra tributária.', AlertType.error); },
        });
    }

    /** Indexa os grupos do catálogo por chave e distribui as fórmulas para cada seção. */
    private distribuirFormulas(grupos: FormulaCatalogoGrupoStruct[]): void {
        const porChave = indexarFormulasContextos(grupos);

        const formulasDiretasPorChave: Record<string, FormulaCatalogoItemStruct[]> = {};
        const indexarFormulasDiretas = (contextos: FormulaCatalogoGrupoStruct[]): void => {
            contextos.forEach(contexto => {
                formulasDiretasPorChave[contexto.chave] = contexto.formulas;
                indexarFormulasDiretas(contexto.filhos);
            });
        };
        indexarFormulasDiretas(grupos);

        // O contexto de cálculo possui duas fórmulas próprias e seções-filhas para CBS/IBS.
        // A base compartilhada recebe somente as fórmulas diretas; as demais recebem sua subárvore.
        this.formulasIbsCbs = formulasDiretasPorChave['regra-tributaria.ibs-cbs.calculo'] ?? [];
        this.formulasCbs = porChave['regra-tributaria.ibs-cbs.calculo.cbs'] ?? [];
        this.formulasIbsUf = porChave['regra-tributaria.ibs-cbs.calculo.ibs-uf'] ?? [];
        this.formulasIbsMunicipio = porChave['regra-tributaria.ibs-cbs.calculo.ibs-municipio'] ?? [];
        this.formulasTribRegular = porChave['regra-tributaria.tributacao-regular.calculo.regular'] ?? [];
        this.formulasMonoPadrao = [
            ...(porChave['regra-tributaria.tributacao-monofasica.calculo.ad-valorem'] ?? []),
            ...(porChave['regra-tributaria.tributacao-monofasica.calculo.padrao'] ?? []),
        ];
        this.formulasMonoRetencao = porChave['regra-tributaria.tributacao-monofasica.calculo.retencao'] ?? [];
        this.formulasMonoRetida = porChave['regra-tributaria.tributacao-monofasica.calculo.retida-anteriormente'] ?? [];
        this.formulasMonoDiferimento = porChave['regra-tributaria.tributacao-monofasica.calculo.diferimento'] ?? [];
        this.formulasCreditoPresumidoOperacao = porChave['regra-tributaria.credito-presumido.operacao'] ?? [];
        this.formulasCreditoPresumidoIbs = porChave['regra-tributaria.credito-presumido.operacao.ibs'] ?? [];
        this.formulasCreditoPresumidoCbs = porChave['regra-tributaria.credito-presumido.operacao.cbs'] ?? [];
        this.formulasRegra = grupos.flatMap(listarFormulasContexto);
    }

    private aplicarResponse(r: RegraTributariaCompletaResponse): void {
        if (!r || r.isError) return;
        this.idRegraTributaria = r.idRegraTributaria;
        this.isEditMode = true;

        // Save incremental: guarda os ids das linhas carregadas para amarrar a origem no save.
        this._origemIds = {
            secaoIbsCbs:             r.idRegraTributariaIbsCbs ?? null,
            ibsCbs:                  r.ibsCbs?.idRegraTributariaGrupoIbsCbs ?? null,
            cbs:                     r.ibsCbs?.cbs?.idRegraTributariaGrupoCbs ?? null,
            ibsUf:                   r.ibsCbs?.ibsUf?.idRegraTributariaGrupoIbsUf ?? null,
            ibsMunicipio:            r.ibsCbs?.ibsMunicipio?.idRegraTributariaGrupoIbsMunicipio ?? null,
            tributacaoRegular:       r.tributacaoRegular?.idRegraTributariaGrupoTributacaoRegularIbsCbs ?? null,
            mono:                    r.mono?.idRegraTributariaGrupoMonoIbsCbs ?? null,
            monoPadrao:              r.mono?.padrao?.idRegraTributariaGrupoMonoIbsCbsPadrao ?? null,
            monoRetencao:            r.mono?.retencao?.idRegraTributariaGrupoMonoIbsCbsRetencao ?? null,
            monoRetidaAnteriormente: r.mono?.retidaAnteriormente?.idRegraTributariaGrupoMonoIbsCbsRetidaAnteriormente ?? null,
            monoDiferimento:         r.mono?.diferimento?.idRegraTributariaGrupoMonoIbsCbsDiferimento ?? null,
            creditoPresumido:        r.creditoPresumido?.idRegraTributariaGrupoCreditoPresumidoOperacaoIbsCbs ?? null,
            creditoPresumidoIbs:     r.creditoPresumido?.ibs?.idRegraTributariaGrupoCreditoPresumidoIbs ?? null,
            creditoPresumidoCbs:     r.creditoPresumido?.cbs?.idRegraTributariaGrupoCreditoPresumidoCbs ?? null,
            impostoSeletivo:         r.impostoSeletivo?.idRegraTributariaIs ?? null,
        };
        this._escopoOrigemPorTipo = new Map((r.escopos ?? []).map(e => [e.tipoEscopo, e.idRegraTributariaEscopo ?? null]));

        this.form.patchValue({
            nome: r.nome,
            isAtivo: r.isAtivo,
            observacao: r.observacao ?? null,
            informacaoFisco: r.informacaoFisco ?? null,
            modelosDocumento: r.modelosDocumento ?? [],
            classificacao: { cstIbsCbs: r.cstIbsCbs, cclassTrib: r.cclassTrib, indDoacao: r.indDoacao },
        });
        if (r.ibsCbs) {
            this.form.get('ibsCbs')?.patchValue({
                ...r.ibsCbs,
                reducaoBaseCalculoAtivo: r.ibsCbs.percentualReducaoBaseCalculo != null,
            });
            this.sincronizarEntesIbsCbs(!!r.ibsCbs.isAtivo);
        }
        if (r.tributacaoRegular) this.form.get('tributacaoRegular')?.patchValue(r.tributacaoRegular);
        if (r.mono) this.form.get('mono')?.patchValue(r.mono);
        if (r.creditoPresumido) this.form.get('creditoPresumido')?.patchValue(r.creditoPresumido);
        if (r.impostoSeletivo) this.form.get('impostoSeletivo')?.patchValue(r.impostoSeletivo);

        // Semeia o estado das fórmulas personalizadas de cada grupo (patchValue não cobre _estadosFormulas).
        this.semearFormulas('ibsCbs', r.ibsCbs?.formulas);
        this.semearFormulas('ibsCbs.cbs', r.ibsCbs?.cbs?.formulas);
        this.semearFormulas('ibsCbs.ibsUf', r.ibsCbs?.ibsUf?.formulas);
        this.semearFormulas('ibsCbs.ibsMunicipio', r.ibsCbs?.ibsMunicipio?.formulas);
        this.semearFormulas('tributacaoRegular', r.tributacaoRegular?.formulas);
        this.semearFormulas('mono.padrao', r.mono?.padrao?.formulas);
        this.semearFormulas('mono.retencao', r.mono?.retencao?.formulas);
        this.semearFormulas('mono.retidaAnteriormente', r.mono?.retidaAnteriormente?.formulas);
        this.semearFormulas('mono.diferimento', r.mono?.diferimento?.formulas);
        this.semearFormulas('creditoPresumido', r.creditoPresumido?.formulas);
        this.semearFormulas('creditoPresumido.ibs', r.creditoPresumido?.ibs?.formulas);
        this.semearFormulas('creditoPresumido.cbs', r.creditoPresumido?.cbs?.formulas);
        this.semearFormulas('impostoSeletivo', r.impostoSeletivo?.formulas);
        this.aplicarEscopos(r.escopos ?? []);
        this._carimboVinculos = r.carimboVinculos ?? null;
        this.naturezasSelecionadas = r.naturezasOperacao ?? [];
        this.form.get('naturezas')?.setValue(this.naturezasSelecionadas.map(n => n.idNaturezaOperacao));
    }

    /** Escreve o estado inicial das fórmulas no control _estadosFormulas do sub-grupo indicado. */
    private semearFormulas(path: string, formulas?: FormulaItemStruct[]): void {
        this.form.get(`${path}._estadosFormulas`)?.setValue(formulas ?? []);
    }

    private montarRequest(): RegraTributariaCompletaRequest {
        const v = this.form.getRawValue();

        return {
            nome: v.nome,
            isAtivo: v.isAtivo,
            observacao: v.observacao?.trim() || null,
            informacaoFisco: v.informacaoFisco?.trim() || null,
            isPadrao: this.isModoPadrao,
            // No tipo padrao a regra atende todos os modelos atualmente suportados pela configuracao.
            modelosDocumento: this.isModoPadrao
                ? this.modelosDocumento.flatMap(modelo => modelo.codigo ? [modelo.codigo] : [])
                : (v.modelosDocumento ?? []),
            indicadores: montarIndicadoresRegraTributaria(this.cstSelecionado()?.indicadores, this.cclasstribSelecionado()?.indicadores, v),
            cstIbsCbs: v.classificacao?.cstIbsCbs ?? null,
            cclassTrib: v.classificacao?.cclassTrib ?? null,
            indDoacao: v.classificacao?.indDoacao ?? null,
            idRegraTributariaIbsCbs: this._origemIds['secaoIbsCbs'] ?? null,
            ibsCbs: v.ibsCbs ? {
                idRegraTributariaGrupoIbsCbs: this._origemIds['ibsCbs'] ?? null,
                isAtivo: v.ibsCbs.isAtivo,
                percentualReducaoBaseCalculo: v.ibsCbs.isAtivo && v.ibsCbs.reducaoBaseCalculoAtivo ? v.ibsCbs.percentualReducaoBaseCalculo ?? null : null,
                formulas: this.mapFormulaItems(v.ibsCbs._estadosFormulas ?? []),
                cbs: this.comFormulas(v.ibsCbs.cbs, 'idRegraTributariaGrupoCbs', this._origemIds['cbs']),
                ibsUf: this.comFormulas(v.ibsCbs.ibsUf, 'idRegraTributariaGrupoIbsUf', this._origemIds['ibsUf']),
                ibsMunicipio: this.comFormulas(v.ibsCbs.ibsMunicipio, 'idRegraTributariaGrupoIbsMunicipio', this._origemIds['ibsMunicipio']),
            } : null,
            tributacaoRegular: this.comFormulas(v.tributacaoRegular, 'idRegraTributariaGrupoTributacaoRegularIbsCbs', this._origemIds['tributacaoRegular']),
            mono: v.mono ? {
                idRegraTributariaGrupoMonoIbsCbs: this._origemIds['mono'] ?? null,
                isAtivo: v.mono.isAtivo,
                padrao: this.comFormulas(v.mono.padrao, 'idRegraTributariaGrupoMonoIbsCbsPadrao', this._origemIds['monoPadrao']),
                retencao: this.comFormulas(v.mono.retencao, 'idRegraTributariaGrupoMonoIbsCbsRetencao', this._origemIds['monoRetencao']),
                retidaAnteriormente: this.comFormulas(v.mono.retidaAnteriormente, 'idRegraTributariaGrupoMonoIbsCbsRetidaAnteriormente', this._origemIds['monoRetidaAnteriormente']),
                diferimento: this.comFormulas(v.mono.diferimento, 'idRegraTributariaGrupoMonoIbsCbsDiferimento', this._origemIds['monoDiferimento']),
            } : null,
            creditoPresumido: v.creditoPresumido ? {
                idRegraTributariaGrupoCreditoPresumidoOperacaoIbsCbs: this._origemIds['creditoPresumido'] ?? null,
                isAtivo: v.creditoPresumido.isAtivo,
                cCredPres: v.creditoPresumido.cCredPres,
                formulas: this.mapFormulaItems(v.creditoPresumido._estadosFormulas ?? []),
                ibs: this.comFormulas(v.creditoPresumido.ibs, 'idRegraTributariaGrupoCreditoPresumidoIbs', this._origemIds['creditoPresumidoIbs']),
                cbs: this.comFormulas(v.creditoPresumido.cbs, 'idRegraTributariaGrupoCreditoPresumidoCbs', this._origemIds['creditoPresumidoCbs']),
            } : null,
            impostoSeletivo: v.impostoSeletivo ? {
                ...v.impostoSeletivo,
                idRegraTributariaIs: this._origemIds['impostoSeletivo'] ?? null,
                formulas: this.mapFormulaItems(v.impostoSeletivo._estadosFormulas ?? []),
            } : v.impostoSeletivo,
            escopos: this.montarEscopos(v),
            naturezasOperacao: this.isModoPadrao ? [] : (v.naturezas ?? []),
            carimboVinculos: this._carimboVinculos,
            ciclosEmpresa: coletarCiclosEmpresa(this.form),
        };
    }

    private montarEscopos(v: any): RegraTributariaEscopoStruct[] {
        if (this.isModoPadrao) return [];
        const escopo = v.escopo ?? {};
        const escopos: RegraTributariaEscopoStruct[] = [];
        const add = (tipoEscopo: TipoEscopoEnum, valores: unknown[]) => {
            const valoresEscopo = (valores ?? []).map(x => String(x)).filter(x => !!x);
            if (valoresEscopo.length > 0) escopos.push({ tipoEscopo, valoresEscopo, idRegraTributariaEscopo: this._escopoOrigemPorTipo.get(tipoEscopo) ?? null });
        };

        add(TipoEscopoEnum.Ncm, escopo.ncms ?? []);
        add(TipoEscopoEnum.Produto, (escopo.produtos ?? []).map((p: any) => p.codigo));
        add(TipoEscopoEnum.ContribIbsCbs, escopo.contribIbsCbs ?? []);
        add(TipoEscopoEnum.RegimeTrib, escopo.regimesTrib ?? []);
        add(TipoEscopoEnum.TipoTributario, escopo.tiposTrib ?? []);

        return escopos;
    }

    private aplicarEscopos(escopos: RegraTributariaEscopoStruct[]): void {
        const valores = (tipo: TipoEscopoEnum) =>
            escopos.find(e => e.tipoEscopo === tipo)?.valoresEscopo ?? [];

        this.form.get('escopo')?.patchValue({
            ncms: valores(TipoEscopoEnum.Ncm),
            produtos: valores(TipoEscopoEnum.Produto).map(codigo => ({ codigo, descricao: codigo })),
            contribIbsCbs: valores(TipoEscopoEnum.ContribIbsCbs),
            regimesTrib: valores(TipoEscopoEnum.RegimeTrib).map(Number),
            tiposTrib: valores(TipoEscopoEnum.TipoTributario).map(Number),
        });

        this.resolverProdutosEscopo(valores(TipoEscopoEnum.Produto));
    }

    /**
     * Os produtos do escopo são persistidos apenas pelo idProduto. Na edição, resolve o SKU e a
     * descrição via lookup para exibir os badges no formato "SKU - Nome".
     */
    private resolverProdutosEscopo(codigos: string[]): void {
        const ids = codigos.map(c => Number(c)).filter(n => Number.isFinite(n) && n > 0);
        if (ids.length === 0) return;

        this.produtoLookupService.getAllSelectByIds(ids).subscribe(resp => {
            const mapa = new Map<string, { descricao: string; sku: string }>();
            (resp?.list ?? []).forEach(p => mapa.set(String(p.idProduto), {
                descricao: p.descricao ?? '',
                sku: p.codigoSku ?? '',
            }));
            const atualizados = (this.form.get('escopo.produtos')?.value ?? []).map((item: any) => {
                const info = mapa.get(String(item.codigo));
                return info ? { codigo: item.codigo, descricao: info.descricao || item.codigo, sku: info.sku } : item;
            });
            // Só enriquece descrição/sku de dados já persistidos (carregamento); não é edição do
            // usuário, então não deve disparar o valueChanges usado para detectar alteração.
            this.form.get('escopo.produtos')?.setValue(atualizados, { emitEvent: false });
        });
    }

    /** Copia o sub-grupo removendo o control interno _estadosFormulas e anexando as fórmulas mapeadas. */
    private comFormulas(grupo: any, campoId: string, idOrigem?: number | null): any {
        if (!grupo) return grupo;
        const { _estadosFormulas, ...resto } = grupo;
        return { ...resto, [campoId]: idOrigem ?? null, formulas: this.mapFormulaItems(_estadosFormulas ?? []) };
    }

    /** Mantém apenas fórmulas com tipo != Padrão (espelha o mapFormulaItems da Natureza de Operação). */
    private mapFormulaItems(estados: FormulaItemStruct[]): FormulaItemStruct[] {
        return (estados ?? [])
            .filter(e => e.tipo !== TipoFormulaEnum.ModeloPadrao)
            .map(e => ({
                chaveFormula: e.chaveFormula,
                idFormulaPersonalizada: e.idFormulaPersonalizada ?? null,
                tipo: e.tipo,
                chaveFormulaModelo: e.chaveFormulaModelo ?? null,
                expressao: e.expressao ?? null,
                tipoArredondamento: e.tipoArredondamento ?? null,
                casasDecimais: e.casasDecimais ?? null,
                dataVigenciaInicio: e.dataVigenciaInicio ?? null,
                dataVigenciaFim: e.dataVigenciaFim ?? null,
            }));
    }

    public salvar(): void {
        if (!this.validarTributacao()) return;

        this.isSaving = true;
        const request = this.montarRequest();

        const chamada = this.isModoPadrao
            ? (this.idRegraTributaria
                ? this.regraService.atualizarPadrao(this.idRegraTributaria, request)
                : this.regraService.criarPadrao(request))
            : (this.idRegraTributaria
                ? this.regraService.atualizarCompleto(this.idRegraTributaria, request)
                : this.regraService.criarCompleto(request));

        chamada.subscribe({
            next: (r) => {
                this.isSaving = false;
                if (r?.isError) {
                    this.tratarErroSalvar(r);
                    return;
                }
                if (r?.conflitoVinculos === true) {
                    this.tratarConflitoVinculos(r.carimboVinculos ?? null);
                    return;
                }
                this.isDirty = false;
                this.alertService.show('Sucesso', 'Regra tributária salva com sucesso.', AlertType.success);
                this.cancelar();
            },
            error: () => {
                this.isSaving = false;
                this.alertService.show('Erro', 'Não foi possível salvar a regra tributária.', AlertType.error);
            },
        });
    }

    /**
     * Erro do salvar. Referência circular ou ciclo alterado abre o modal de ciclo com o ciclo devolvido pela API;
     * ao confirmar, o rascunho é acrescentado a `_ciclosEmpresa` e o salvar é repetido, um ciclo por vez. Cancelar preserva o
     * formulário e avisa com texto fixo. Os demais códigos (ciclo ambíguo, pontos de decisão inválidos etc.) só avisam.
     */
    private tratarErroSalvar(response: RegraTributariaSalvarResponse): void {
        const erros = response.erros ?? [];
        const erroCiclo = erros.find(item =>
            (item.codigo === FormulaErrorCodeEnum.ReferenciaCircular || item.codigo === FormulaErrorCodeEnum.CicloAlterado
                || item.codigo === FormulaErrorCodeEnum.CicloPontosDecisaoInvalidos)
            && item.ciclo?.membros?.length);
        if (!erroCiclo?.ciclo) {
            const mensagem = erros.map(item => item.mensagem).filter(Boolean).join('\n')
                || response.errorDescription || 'Não foi possível salvar a regra tributária.';
            this.alertService.show('Erro', mensagem, AlertType.error);
            return;
        }

        const data: FormulaCicloDialogData = {
            ciclo: erroCiclo.ciclo,
            titulo: 'Referência circular entre fórmulas',
            tipoEntidadeEdicao: TipoEntidadeFormulaEnum.RegraTributaria,
            idEntidadeEdicao: this.idRegraTributaria,
        };
        this.dialog.open(FormulaCicloDialogComponent, { width: '760px', maxWidth: '96vw', maxHeight: '92vh', data })
            .afterClosed().subscribe((rascunho: FormulaCicloDialogResult | null) => {
                if (!rascunho) {
                    this.alertService.show('Atenção', 'O salvamento foi cancelado: escolha por onde o cálculo começa para salvar.', AlertType.warning);
                    return;
                }
                registrarCicloEmpresa(this.form, rascunho);
                this.salvar();
            });
    }

    /**
     * Trava otimista (Opção 3): outro usuário alterou os vínculos da linhagem desde que a tela
     * carregou; o backend não salvou nada. Recarrega apenas a seção de naturezas selecionadas
     * (GET dedicado), atualiza o carimbo e mantém o restante do formulário para o usuário revisar
     * e salvar de novo.
     */
    private tratarConflitoVinculos(carimboRetornado: string | null): void {
        this._carimboVinculos = carimboRetornado;
        this.alertService.show(
            'Atenção',
            'Os vínculos com naturezas da operação foram alterados por outro usuário e nada foi salvo. A lista de naturezas selecionadas foi atualizada. Revise e salve novamente.',
            AlertType.warning,
        );

        if (!this.idRegraTributaria) return;

        this.regraService.getNaturezasVinculadas(this.idRegraTributaria).subscribe({
            next: (resp) => {
                if (!resp || resp.isError) return;
                this._carimboVinculos = resp.carimboVinculos ?? this._carimboVinculos;
                this.naturezasSelecionadas = resp.naturezas ?? [];
                this.form.get('naturezas')?.setValue(this.naturezasSelecionadas.map(n => n.idNaturezaOperacao));
            },
        });
    }

    public cancelar(): void {
        const urlLista = this.isModoPadrao ? '/configuracoes/reforma-tributaria' : '/configuracoes/reforma-tributaria/regras';
        if (!this.isDirty) {
            this.router.navigate([urlLista]);
            return;
        }
        this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Descartar alterações?',
                description: 'Há alterações não salvas nesta regra tributária. Deseja sair mesmo assim?',
                buttonConfirm: 'Descartar',
                buttonClose: 'Voltar',
            },
        }).afterClosed().subscribe(result => {
            if (result?.confirm) this.router.navigate([urlLista]);
        });
    }

    public irParaEtapa(indice: number): void {
        if (!this.isModoPadrao && indice >= 0 && indice < this.etapas.length) {
            this.etapaAtual = indice;
        }
    }
}
